// this action is used to store businessServices, tenantId, fetched application count department side.

export const types = {
  UPDATE_DETAILS: "UPDATE_DETAILS",
};

export const updateFormData = (businessServices, tenantId, count, officerRole) => ({
  type: types.UPDATE_DETAILS,
  payload: { businessServices, tenantId, count, officerRole },
});
